export default function Home() {
    return (
            <section
                className="relative py-20 text-center bg-cover bg-center"
                style={{ backgroundImage: "url('/backgrounds/balloon.png')" }}
            >
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-b from-blue-100/70 to-white/70"></div>

                {/* Content */}
                <div className="relative z-10">
                    {/* Hero Section */}
                    <h1 className="text-5xl font-extrabold text-blue-600 mb-6">
                        🎈 Popalooza – Joyful Balloon Adventures
                    </h1>
                    <p className="text-lg text-gray-700 mb-8 max-w-2xl mx-auto">
                        Play, laugh, and rise to new heights in the world of Popalooza.
                    </p>
                    <a
                        href="https://play.google.com/store/apps/details?id=com.thinksoftweb.Popalooza"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block bg-blue-600 text-white px-8 py-3 rounded-lg shadow hover:bg-blue-700 transition"
                    >
                        Download Now on Google Play
                    </a>

                    {/* Full Description */}
                    <div className="mt-16 max-w-4xl mx-auto text-left space-y-8">
                        <h2 className="text-3xl font-bold text-blue-600 text-center">
                            🎉 Popalooza – Balloon Popping Fun for Kids, Families, and Casual Gamers 🎉
                        </h2>
                        <p className="text-gray-700 leading-relaxed">
                            Popalooza is more than just a balloon game – it’s a joyful arcade adventure designed for
                            players of all ages. Whether you’re a parent looking for safe entertainment for your child,
                            a casual gamer chasing high scores, or a family wanting a fun activity together, Popalooza
                            delivers endless excitement.
                        </p>

                        <h3 className="text-2xl font-semibold text-blue-600">🌟 Why You’ll Love Popalooza</h3>
                        <ul className="list-disc list-inside space-y-2 text-gray-700">
                            <li>Easy to Play: Simple tap controls make it perfect for preschoolers, kids, and adults alike.</li>
                            <li>Educational Arcade: Improve reflexes, focus, and hand‑eye coordination while having fun.</li>
                            <li>Exciting Levels: Progress through multiple stages with new balloon types and mechanics.</li>
                            <li>Unique Balloons: Bonus, slowmo, sparkle, ghost, starburst, etc – each adds a twist to gameplay.</li>
                            <li>Dynamic Challenges: Every round feels fresh with balloons spawning at different speeds and positions.</li>
                            <li>Leaderboards: Compete with friends, track your best scores, and celebrate progress.</li>
                            <li>Offline Play: Enjoy Popalooza anytime, anywhere – no internet required.</li>
                            <li>Family Friendly: Safe, joyful, and designed to bring smiles without inappropriate content.</li>
                        </ul>

                        <h3 className="text-2xl font-semibold text-blue-600">💎 Subscription Option</h3>
                        <p className="text-gray-700 leading-relaxed">
                            Want uninterrupted fun? Subscribe monthly for ad‑free gameplay.
                        </p>
                        <ul className="list-disc list-inside space-y-2 text-gray-700">
                            <li>No Ads: Play without distractions.</li>
                            <li>Support Development: Help us expand levels, add new balloon types, and deliver more exciting features.</li>
                        </ul>

                        <h3 className="text-2xl font-semibold text-blue-600">🚀 Coming Soon</h3>
                        <ul className="list-disc list-inside space-y-2 text-gray-700">
                            <li>Seasonal events and themed challenges to keep gameplay fresh.</li>
                            <li>Expanded level progression beyond the initial set.</li>
                            <li>More creative balloon varieties with special powers.</li>
                            <li>Localization for multiple languages to reach global players.</li>
                        </ul>

                        <h3 className="text-2xl font-semibold text-blue-600">✨ Why Choose Popalooza?</h3>
                        <p className="text-gray-700 leading-relaxed">
                            Popalooza combines fun, challenge, and progression in a way that’s easy to pick up but hard
                            to put down. It’s lightweight, runs smoothly on most devices, and offers a polished
                            experience with vibrant animations, playful sound effects, and haptic feedback. Whether
                            you’re chasing scores, unlocking levels, or simply enjoying the satisfying pop of balloons,
                            Popalooza is designed to bring joy to everyone.
                        </p>

                        <h3 className="text-2xl font-semibold text-blue-600">📲 Download Popalooza Today</h3>
                        <p className="text-gray-700 leading-relaxed">
                            Start popping your way to the top! Perfect for kids, families, and anyone who loves casual
                            arcade fun.
                        </p>
                        <div className="text-center">
                            <a
                                href="https://play.google.com/store/apps/details?id=com.thinksoftweb.Popalooza"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-block bg-blue-600 text-white px-8 py-3 rounded-lg shadow hover:bg-blue-700 transition"
                            >
                                Download Now on Google Play
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            );
}
